module.exports = __webpack_public_path__ + "img/add-photo.66117406.svg";